/**
 * Frontend configuration sourced from Vite env vars.
 *
 * The values default to the docker-compose stack so a fresh
 * ``npm run dev`` works out of the box.  Override per environment via
 * ``VITE_ANC_*`` env vars in ``.env.local`` / CI.
 */
const env = import.meta.env;

export const ANC_API_BASE_URL: string =
  env.VITE_ANC_API_BASE_URL ?? "http://localhost:8000";

export const ANC_OIDC_CONFIG = {
  authority:
    env.VITE_ANC_OIDC_AUTHORITY ?? "http://localhost:8080/realms/anc",
  clientId: env.VITE_ANC_OIDC_CLIENT_ID ?? "anc-frontend",
  redirectUri:
    env.VITE_ANC_OIDC_REDIRECT_URI ??
    `${window.location.origin}/oauth/callback`,
  postLogoutRedirectUri:
    env.VITE_ANC_OIDC_POST_LOGOUT_REDIRECT_URI ?? window.location.origin,
};
